import { render, staticRenderFns } from "./NavbarCanadian.vue?vue&type=template&id=e16f73fc&scoped=true&"
import script from "./NavbarCanadian.vue?vue&type=script&lang=js&"
export * from "./NavbarCanadian.vue?vue&type=script&lang=js&"
import style0 from "./NavbarCanadian.vue?vue&type=style&index=0&id=e16f73fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e16f73fc",
  null
  
)

export default component.exports